import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import clsx from 'clsx';
import { FormSize } from "../../../../../view-model";
import { useFormCommonProps } from "../../../../context/form-common";
import { nanoid } from 'nanoid';
export const InputRadioButton = props => {
  var _value$checked;
  const {
    label,
    className = 'btn-pill btn-outline-default',
    onChange,
    onFocus,
    onBlur,
    value,
    error,
    size = FormSize.SM,
    readOnly,
    disabled,
    children
  } = useFormCommonProps(props);
  const id = React.useMemo(() => nanoid(), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    id: id,
    type: "radio",
    className: "btn-check",
    checked: (_value$checked = value === null || value === void 0 ? void 0 : value.checked) !== null && _value$checked !== void 0 ? _value$checked : false,
    disabled: disabled || readOnly,
    onChange: e => {
      onChange && onChange(_objectSpread(_objectSpread({}, value), {}, {
        checked: e.target.checked
      }));
    },
    onFocus: () => onFocus && onFocus(),
    onBlur: () => onBlur && onBlur()
  }), (label || children) && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: clsx('btn', className, {
      disabled
    }, {
      'btn-sm': size === FormSize.SM,
      'btn-lg': size === FormSize.LG,
      'btn-xl': size === FormSize.XL,
      error: error
    })
  }, label !== null && label !== void 0 ? label : children));
};